export default __webpack_public_path__ + "static/473-a7ca953c4c3053d84c2cfd1fee36569c.gif";